export default (requestId: string = '<not present>') => requestId;
